module.exports = __webpack_public_path__ + "static/img/file_c#.32df8cde.png";